import React from 'react'
import { graphql } from 'gatsby'
import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import Video from '@/components/Video'
import Share from '@/components/Share'
import { dasherize } from '@/utilities'
import Page from '@/components/Page'

const hashtags = ['claroempresaswebinar']

const PageTemplate = ({ data }) => {
  console.log(data)
  const { strapiPage } = data
  return (
    <Layout>
      <SEO title={strapiPage.title} />
      <Page pagedata={strapiPage} />
    </Layout>
  )
}

export default PageTemplate

export const query = graphql`
  query pageQuery($id: String!) {
    strapiPage(slug: { eq: $id }) {
      title
      slug
      content {
        block
        component
      }
    }
  }
`
